/** PostHog US Cloud ingest host — same across all environments today. */
export const POSTHOG_HOST = 'https://us.i.posthog.com';

/**
 * CON-8444 PDP gallery experiment. Must match PDP_GALLERY_REVAMP_FLAG in
 * joystagram's useIsGalleryRevampVariant.js.
 */
export const PDP_GALLERY_REVAMP_FLAG = 'pdp-gallery-revamp';

/**
 * CON-8777 PDP customization & layout experiment. Must match
 * PDP_LAYOUT_REVAMP_FLAG in joystagram's useIsLayoutRevampVariant.js.
 */
export const PDP_LAYOUT_REVAMP_FLAG = 'pdp-layout-revamp';
